package com.milta.core.localization.translations.nl

import com.milta.core.localization.LoadingAddressStrings

internal val LoadingAddress = LoadingAddressStrings(
    title = "Laadadres",
    emptyMessage = "Geef aan waar uw chauffeurs de goederen laden om de rit te optimaliseren. Het adres wordt bewaard voor uw volgende ritten.",
    selectPlaceholder = "Kies een laadadres",
    sheetSubtitle = "Waar uw chauffeurs de goederen ophalen.",
    startPointBadge = "Vertrekpunt",
    newAddressAction = "Nieuw adres",
    mobileSearchPlaceholder = "Straat, nummer, gemeente",
    webSearchPlaceholder = "Zoek een adres…",
    deleteDialogTitle = "Dit adres verwijderen?",
    deleteDialogMessage = "„%s” wordt niet meer voorgesteld. Reeds aangemaakte ritten blijven ongewijzigd.",
    webSubmitBlockedHint = "Kies een laadadres om te optimaliseren.",
    errorRequired = "Kies een laadadres.",
)
